// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetAISummary-moduleaiSummaryContent__ovW9p WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "RequestProfileWidgetAISummary-moduleaiSummaryWidget__ysk3q ProfileAISummaryWidget-moduleProfileAISummaryWidget__B5VA7 Widget-moduleWidget__bcnWB";
export { _1 as "aiSummaryContent", _2 as "aiSummaryWidget" }
